function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Emoji_hug");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "P_St_A",
  transform: "translate(-420.000000, -482.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(409.000000, 473.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Emoji_hug",
  transform: "translate(12.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "color",
  transform: "translate(0.378000, 0.000000)",
  fill: "#FCEA2B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 10.584,
  cy: 9.072,
  r: 8.9964
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.113400, 13.797000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.6356,5.1408 L5.7078,7.1064 C4.017384,5.798898 1.75392,5.44509 0.3213,3.79512 C0.1278774,2.760912 -0.174636,0.01134 1.022112,1.0206 C2.89548,-0.23058 2.676996,1.541862 4.839912,2.079 L4.915512,2.079 C4.6757844,1.031184 4.26951,1.08675 5.066712,0.3024 C6.425244,1.792098 6.405588,3.925908 7.637112,5.1408 L7.6356,5.1408 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7626,0.4158 C16.363998,0.7386498 15.946308,1.786428 15.9516,2.1924 C16.5942,2.0034 17.8038,1.2852 18.5598,0.6804 C19.16271,0.6981093 21.567924,1.164618 20.7522,1.9656 C20.7522,1.9656 21.2058,2.1168 20.7522,3.0996 C20.4876,3.2886 20.6766,4.0068 20.3742,4.3848 C18.810792,5.94783 16.19352,5.563026 15.309,7.1442 L13.3434,5.1786 C14.73822,3.90852 14.083524,1.414098 15.7626,0.4158 L15.7626,0.4158 Z",
  id: "Path"
}))), /*#__PURE__*/React.createElement("g", {
  id: "line",
  transform: "translate(0.000000, 0.378000)",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeWidth: 0.756
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.5976,12.852 C19.278,11.5668 19.656,10.1304 19.656,8.694 C19.656,3.8934 15.7626,0 10.962,0 C6.1614,0 2.268,3.8934 2.268,8.694 C2.268,10.0926 2.6082,11.4912 3.2886,12.7386 C3.2886,12.7764 3.2886,12.7764 3.3264,12.8142",
  id: "Path",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5428,17.0478 C9.3366,17.2746 10.1304,17.388 10.962,17.388 C11.7558,17.388 12.5496,17.2746 13.3056,17.0856",
  id: "Path",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6664,12.1716 C12.5118,13.9482 9.4122,13.9482 7.2576,12.1716",
  id: "Path",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.3366,7.7112 C8.9586,6.804 7.9002,6.3882 6.993,6.804 C6.5772,6.993 6.2748,7.2954 6.0858,7.7112",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8382,7.7112 C15.4602,6.804 14.4018,6.3882 13.4946,6.804 C13.0788,6.993 12.7764,7.2954 12.5874,7.7112",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.0514,18.4086 C7.712523,18.1196946 7.463988,17.892252 7.371,17.5014 C7.2792972,16.373826 6.785478,15.320718 6.3126,14.4396 C6.1992,14.2506 5.9724,13.6836 5.7456,13.608 C5.4054,13.4946 5.1786,13.608 5.103,14.0238 C5.0274,14.4396 5.3298,15.2712 5.4054,15.498 C4.514454,15.024366 3.677562,14.474754 2.9862,13.9482 C2.5326,13.6836 2.1546,13.797 1.9656,14.0994 C1.89,14.2128 1.89,14.2884 1.8522,14.364 C1.2852,13.9482 0.8694,14.0994 0.6804,14.364 C0.4914,14.5908 0.4914,14.931 0.6426,15.1578 C0.567,15.1956 0.4914,15.2712 0.4536,15.3468 C0.2268,15.7248 0.3402,16.2162 0.7182,16.443 C0.7938,16.4808 0.9072,16.5942 1.0584,16.6698 C1.0206,16.7076 0.9828,16.7076 0.9828,16.7454 C0.7938,16.9722 0.7938,17.3502 0.9828,17.577 C1.5876,18.6354 4.3848,19.4292 5.3298,19.656 L6.0102,20.3364",
  id: "Path",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.7248,20.3364 L16.4052,19.656 C17.3502,19.4292 20.1474,18.5976 20.7522,17.577 C20.9412,17.3502 20.9412,16.9722 20.7144,16.7832 C20.6766,16.7454 20.6766,16.7076 20.6388,16.7076 C20.8278,16.5942 20.9412,16.4808 20.979,16.4808 C21.357,16.254 21.4704,15.7626 21.2436,15.3846 C21.2058,15.309 21.1302,15.2334 21.0546,15.1956 C21.2058,14.9688 21.2058,14.6286 21.0168,14.4018 C20.8278,14.175 20.412,13.986 19.845,14.4018 C19.845,14.2884 19.8072,14.175 19.7316,14.1372 C19.5426,13.8726 19.2024,13.7214 18.711,13.986 C18.711,13.986 18.6732,13.986 18.6732,14.0238 C17.955,14.6286 17.1234,15.12 16.2918,15.5358 C16.4817828,15.049692 16.93062,13.338108 16.065,13.608 C15.8382,13.6836 15.6114,14.2506 15.498,14.4396 C14.841036,15.388758 14.644476,16.412004 14.4396,17.5014 C14.4513256,17.908506 14.032872,18.134928 13.7592,18.4086",
  id: "Path",
  strokeLinejoin: "round"
}))))));

var SvgHug = function SvgHug(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHug, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hug.9ac42077.svg";
export { ForwardRef as ReactComponent };